import { render, staticRenderFns } from "./BarChartDashboard.vue?vue&type=template&id=d03a1f7c&lang=pug&"
import script from "./BarChartDashboard.vue?vue&type=script&lang=js&"
export * from "./BarChartDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports